
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import type { GetStaticProps } from 'next';
import useTranslation from 'next-translate/useTranslation';
import StaticPageTemplate from '@/components/StaticTemplate';
import Image from 'next/image';
import type { AccountManager as AccountManagerType } from '@/lib/types/bevmaq.types';
import { VideoWeAreBevMaq } from '@/components/VideoWeAreBevMaq';
import { AccountManager } from '../components/AccountManager';
import { getAccountManagerByLocale } from '@/lib/utilities/repository';
import Trans from 'next-translate/Trans';

function Index({ accountManager }: { accountManager: AccountManagerType }) {
  const { t } = useTranslation();
  const title = t('common:Company');
  const subtitle = '';
  const components = [
    <div className='!mt-0 flex flex-col items-center bg-white' key='company'>
      <div className='grid max-w-7xl gap-4 bg-white lg:grid-cols-2'>
        <div className='flex flex-col justify-center space-y-4 py-4 lg:pb-52'>
          <h3 className='subtitle'>
            <Trans
              i18nKey='common:company.subtitle'
              components={{
                link: <a href='' className='text-primary' />,
              }}
            />
          </h3>
          <h3 className='text-lg'>{t('common:company.subtitle2')}</h3>
        </div>
        <div className=''>
          <div className='aspect-h-4 aspect-w-8  w-full overflow-hidden rounded-lg pb-0 group-hover:opacity-75'>
            <div className='relative h-[35em] w-full'>
              <Image
                src='/bevmaq_team.jpg'
                alt='Image of the product'
                fill
                className='object-contain'
              />
            </div>
          </div>
        </div>
      </div>
      <VideoWeAreBevMaq />
      <AccountManager
        accountManager={accountManager}
        containerClasses='bg-white'
      />
    </div>,
  ];

  return (
    <StaticPageTemplate
      title={title}
      subtitle={subtitle}
      components={components}
    />
  );
}

 const _getStaticProps: GetStaticProps = async ({ locale }) => {
  const accountManager = await getAccountManagerByLocale(locale);

  return {
    props: { hasContainer: false, accountManager: accountManager },
  };
};

export default Index;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/company',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  